import { render, staticRenderFns } from "./FlexibilityPanel.vue?vue&type=template&id=718dc3e2&scoped=true&"
import script from "./FlexibilityPanel.vue?vue&type=script&lang=js&"
export * from "./FlexibilityPanel.vue?vue&type=script&lang=js&"
import style0 from "./FlexibilityPanel.vue?vue&type=style&index=0&id=718dc3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718dc3e2",
  null
  
)

export default component.exports